// Static content for the Community Guidelines page.
// Kept as plain data (instead of PageBuilder / hosted assets) so the page
// no longer depends on a fetched "community-guidelines" page asset.
//
// All prose is referenced by translation message id (see en.json / th.json,
// keys prefixed "CommunityGuidelinesPage.") so the content can be localized.

export const companyInfo = {
  name: 'Metta People Co., Ltd.',
  effectiveDate: 'July 2026',
};

// Block types used below:
// p        -> paragraph, { id }
// callout  -> highlighted panel, { id, email? } (email rendered as mailto link)

export const guidelineSections = [
  {
    number: '1',
    titleId: 'CommunityGuidelinesPage.s1.title',
    accentBar: true,
    blocks: [{ type: 'p', id: 'CommunityGuidelinesPage.s1.body' }],
  },
  {
    number: '2',
    titleId: 'CommunityGuidelinesPage.s2.title',
    gradient: true,
    blocks: [{ type: 'p', id: 'CommunityGuidelinesPage.s2.body' }],
  },
  {
    number: '3',
    titleId: 'CommunityGuidelinesPage.s3.title',
    accentBar: true,
    blocks: [{ type: 'p', id: 'CommunityGuidelinesPage.s3.body' }],
  },
  {
    number: '4',
    titleId: 'CommunityGuidelinesPage.s4.title',
    gradient: true,
    blocks: [{ type: 'p', id: 'CommunityGuidelinesPage.s4.body' }],
  },
  {
    number: '5',
    titleId: 'CommunityGuidelinesPage.s5.title',
    accentBar: true,
    blocks: [{ type: 'p', id: 'CommunityGuidelinesPage.s5.body' }],
  },
  {
    number: '6',
    titleId: 'CommunityGuidelinesPage.s6.title',
    gradient: true,
    blocks: [{ type: 'p', id: 'CommunityGuidelinesPage.s6.body' }],
  },
  {
    number: '7',
    titleId: 'CommunityGuidelinesPage.s7.title',
    accentBar: true,
    blocks: [{ type: 'p', id: 'CommunityGuidelinesPage.s7.body' }],
  },
  {
    titleId: 'CommunityGuidelinesPage.violations.title',
    gradient: true,
    blocks: [{ type: 'p', id: 'CommunityGuidelinesPage.violations.body' }],
  },
  {
    blocks: [
      {
        type: 'callout',
        id: 'CommunityGuidelinesPage.reportCallout',
        email: 'info@mettapeople.com',
      },
    ],
  },
];
